// extracted by mini-css-extract-plugin
export default {"wrapper":"RY","product_img":"SY","info":"TY","image":"UY","remove_btn":"VY"};
    if(module.hot) {
      // 1715091684238
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  